module.exports = __webpack_public_path__ + "static/media/paper.c9c90a96.svg";